"use client";

import { APP_URLS } from "@shared/constants.urls";
import { dispatch } from "@shared/utils.events";
import { navigateTo } from "@shared/utils.routing";
import { ProfileIcon } from "components/SVG";
import React from "react";

import {
  navStickyFooter,
  navStickyFooterLink,
  navStickyFooterWrapper,
  stickyNavItem,
  stickyNavItemSpan,
  verticalSeparator
} from "./NavStickyFooter.css";
import { HeartOutlineIcon } from "@shared/ui.icons";

export const NavStickyFooter = (): JSX.Element => {
  const { memberBenefits, wishlist } = APP_URLS;

  return (
    <div className={navStickyFooterWrapper}>
      <div className={navStickyFooter}>
        <div className={navStickyFooterLink}>
          <button
            type="button"
            className={stickyNavItem}
            onClick={() => {
              dispatch("page element clicked", {
                target: "Member Benefits",
                details: "Mobile Navigation",
                location: "Sticky Footer"
              });

              navigateTo(memberBenefits);
            }}
          >
            <ProfileIcon />
            <span className={stickyNavItemSpan}>My Account</span>
          </button>
        </div>
        <div className={verticalSeparator} />
        <div className={navStickyFooterLink}>
          <button
            type="button"
            className={stickyNavItem}
            onClick={() => {
              dispatch("page element clicked", {
                target: "My Wishlist",
                details: "Mobile Navigation",
                location: "Sticky Footer"
              });
              navigateTo(wishlist);
            }}
          >
            <HeartOutlineIcon />
            <span className={stickyNavItemSpan}>My Wishlist</span>
          </button>
        </div>
      </div>
    </div>
  );
};
